const writers = {
  박가람: {
    role: "백엔드 개발자",
    nickname: "가람",
    avatar: "/avatar/garam.park.jpg",
    github: "https://github.com/garam-park",
    contact: "garam.park@themoin.com",
    desc: "여유럽고 행복하게",
  },
  박지현: {},
  안준수: {},
  이경호: {
    role: "프론트엔드 개발자",
    nickname: "경호",
    avatar: "/avatar/kyeongho.png",
    github: "https://github.com/dodonmountain",
    contact: "kyeongho.lee@themoin.com",
    desc: "리.액.트.조.아",
  },
  이유동: {},
  전범준: {},
};

export default writers;
